
<div class = "resume">
  <label class="custom-file-upload">
    <i class = "fa fa-upload" [ngClass] = "{'enableText' : userData?.resumeUrl?.name}"></i>
    <p *ngIf="userData?.resumeUrl?.name" class = "text" [ngClass] = "{'enableText' : userData?.resumeUrl?.name}">{{userData?.resumeUrl?.name}}</p>
    <p *ngIf="!userData?.resumeUrl?.name" class="text" >
      <strong>Upload your CV</strong>. Please ensure that you upload documents in the appropriate format (e.g., PDF, Word)
    </p>
    <input name = "resumeUrl" [placeholder] = "blankResume" #imageInput id="chooseFile" type="file" (change)="onFileChange($event, imageInput)">
  </label>
  <i *ngIf="userData?.resumeUrl?.name && showRemoveIcon" class = "fa fa-trash removeIcon" (click)="removeFile()"></i>
</div>